import * as React from "react"

const TargetNewCross = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={401.5}
    height={401.5}
    {...props}
  >
    <path
      style={{
        fill: "#999",
        fillRule: "evenodd",
        stroke: "#777",
        strokeWidth: 1.5,
        strokeLinejoin: "round",
        strokeMiterlimit: 4,
        strokeOpacity: 1,
        fillOpacity: 1,
      }}
      d="M190.75 220.75h20M190.75 240.75h20M190.75 260.75h20M190.75 280.75h20M190.75 300.75h20M190.75 320.75h20M190.75 340.75h20M190.75 360.75h20M190.75 380.75h20M190.75 400.75h20M190.75 180.75h20M190.75 160.75h20M190.75 140.75h20M190.75 120.75h20M190.75 100.75h20M190.75 80.75h20M190.75 60.75h20M190.75 40.75h20M190.75 20.75h20M190.75.75h20M180.75 190.75v20M160.75 190.75v20M140.75 190.75v20M120.75 190.75v20M100.75 190.75v20M80.75 190.75v20M60.75 190.75v20M40.75 190.75v20M20.75 190.75v20M.75 190.75v20M220.75 190.75v20M240.75 190.75v20M260.75 190.75v20M280.75 190.75v20M300.75 190.75v20M320.75 190.75v20M340.75 190.75v20M360.75 190.75v20M380.75 190.75v20M400.75 190.75v20"
    />
  </svg>
)

export default TargetNewCross
